Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    COLORS = _STYLES$useStyles.COLORS,
    spacing = _STYLES$useStyles.spacing,
    grid = _STYLES$useStyles.grid,
    bp = _STYLES$useStyles.bp,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight,
    fontBold = _STYLES$useStyles.fontBold,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    boxShadows = _STYLES$useStyles.boxShadows,
    input = _STYLES$useStyles.input;
  var _spacer = spacing.normal;
  if (bp.tablet) {
    _spacer = spacing.s;
  }
  var container = {
    maxWidth: _reactNative.Platform.OS === 'web' ? "calc(".concat(grid.maxTextWidth, " + (").concat(_spacer, " * 2))") : grid.maxTextWidth + _spacer * 2,
    width: '100%',
    marginHorizontal: 'auto',
    marginTop: spacing.page.padding.paddingTop,
    marginBottom: spacing.page.padding.paddingBottom,
    alignSelf: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'stretch'
  };
  var containerItem = {
    paddingBottom: spacing.l,
    width: '100%',
    alignItems: 'center'
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    containerItem.width = '50%';
    containerItem.paddingLeft = _spacer;
    containerItem.paddingRight = _spacer;
  }
  if (bp.desktop) {
    containerItem.paddingBottom = spacing.xl;
  }
  var boxPaddingHorizontal = spacing.l;
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    boxPaddingHorizontal = spacing.xs;
  }
  var box = {
    backgroundColor: COLORS.white,
    borderRadius: (0, _styles.getREM)(1),
    borderWidth: (0, _styles.getREM)(0.125),
    borderStyle: 'solid',
    borderColor: COLORS.steam,
    paddingTop: spacing.page.padding.paddingTop,
    paddingBottom: spacing.page.padding.paddingBottom,
    paddingLeft: boxPaddingHorizontal,
    paddingRight: boxPaddingHorizontal,
    maxWidth: grid.maxCardWidth,
    width: '100%',
    minHeight: '100%'
  };
  var title = Object.assign({}, fontBold, {
    color: colors.brand,
    textAlign: 'center',
    marginBottom: 0
  });
  var subTitle = Object.assign({}, fontSemiBold, {
    textAlign: 'center',
    marginTop: spacing.xs,
    marginBottom: spacing.page.padding.paddingBottom,
    textTransform: 'capitalize',
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    color: colors.brand
  });
  var emptyMessage = Object.assign({}, fontRegular, {
    fontSize: fontSize.normal,
    lineHeight: lineHeight.normal,
    color: colors.brand,
    textAlign: 'center',
    backgroundColor: COLORS.whisper,
    padding: spacing.normal,
    borderRadius: (0, _styles.getREM)(1),
    width: '100%'
  });
  var sort = {
    alignItems: 'center',
    flexDirection: 'row',
    flexShrink: 1,
    flexGrow: 0,
    marginBottom: spacing.page.padding.paddingBottom,
    flexBasis: input.height
  };
  if (bp.not([bp.tablet, bp.desktop])) {
    sort.marginTop = spacing.m;
  }
  var sortLabel = Object.assign({}, fontBold, {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal,
    marginRight: spacing.normal,
    color: colors.brand,
    flexShrink: 0
  });
  var sortSelect = {
    marginBottom: 0,
    flexShrink: 1
  };
  var tileContainer = {
    gap: spacing.l,
    flexDirection: 'column'
  };
  var tile = Object.assign({}, _reactNative.Platform.select({
    web: {
      boxShadow: '0 0.125rem 0.25rem 0.125rem rgba(95, 43, 104, 0.15)'
    }
  }), {
    borderStyle: 'solid',
    borderWidth: (0, _styles.getREM)(0.1875),
    borderColor: COLORS.white,
    backgroundColor: COLORS.paper,
    padding: spacing.normal,
    gap: spacing.normal,
    flexDirection: 'row',
    borderRadius: (0, _styles.getREM)(1),
    minWidth: '70%',
    maxWidth: '100%',
    width: '100%'
  });
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    tile.flexDirection = 'column';
    tile.padding = spacing.xs;
    tile.alignItems = 'center';
    tile.gap = spacing.xs;
  }
  var tileContent = {
    flexDirection: 'column',
    gap: spacing.xs,
    alignItems: 'flex-start',
    flexShrink: 1
  };
  var tileImage = {
    width: (0, _styles.getREM)(3.75),
    height: (0, _styles.getREM)(3.75)
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
    tileImage.width = (0, _styles.getREM)(2.5);
    tileImage.height = (0, _styles.getREM)(2.5);
  }
  var tileLabel = Object.assign({}, fontSemiBold, {
    fontSize: fontSize.normal,
    lineHeight: lineHeight.normal,
    color: colors.brand
  });
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    tileLabel.fontSize = fontSize.s;
    tileLabel.lineHeight = lineHeight.s;
    tileLabel.textAlign = 'center';
    tileLabel.alignSelf = 'center';
  }
  var tileValue = Object.assign({}, fontSemiBold, {
    borderStyle: 'solid',
    borderColor: COLORS.steam,
    borderWidth: (0, _styles.getREM)(0.125),
    borderRadius: (0, _styles.getREM)(1),
    textAlign: 'center',
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    color: colors.brand,
    backgroundColor: COLORS.white,
    paddingVertical: spacing.xxs,
    paddingHorizontal: spacing.s,
    textTransform: 'uppercase'
  });
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    tileValue.alignSelf = 'center';
  }
  var tileLinkContainer = {
    position: 'absolute',
    zIndex: 1,
    top: (0, _styles.getREM)(-0.1875),
    left: (0, _styles.getREM)(-0.1875),
    bottom: (0, _styles.getREM)(-0.1875),
    right: (0, _styles.getREM)(-0.1875)
  };
  var tileLink = {
    width: '100%',
    height: '100%'
  };
  var linkContainer = {
    alignSelf: 'center',
    paddingTop: spacing.page.padding.paddingTop,
    marginTop: 'auto'
  };
  var linkIcon = {
    marginLeft: spacing.s,
    verticalAlign: 'middle'
  };
  var confettiContainer = {
    position: 'absolute',
    zIndex: -1,
    top: _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(spacing.page.padding.paddingTop, ")") : -1 * spacing.page.padding.paddingTop,
    left: _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(boxPaddingHorizontal, ")") : -1 * boxPaddingHorizontal,
    right: _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(boxPaddingHorizontal, ")") : -1 * boxPaddingHorizontal,
    bottom: 0
  };
  var confettiLeft = {
    position: 'absolute',
    top: '-10%',
    left: 0,
    width: '40%',
    height: '130%'
  };
  var confettiRight = {
    position: 'absolute',
    right: 0,
    bottom: 0,
    width: '35%',
    height: '140%'
  };
  var podium = {
    gap: spacing.l
  };
  if (bp.not([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    podium.flexDirection = 'row';
    podium.alignItems = 'flex-end';
    podium.gap = 0;
  }
  var podiumItem = {
    flexShrink: 1,
    flexGrow: 1,
    flexBasis: 0
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    podiumItem.flexBasis = '100%';
  }
  var podiumItemImage = {
    alignSelf: 'center',
    marginBottom: (0, _styles.getREM)(2)
  };
  var podiumItemImage_first = {
    marginBottom: 0,
    marginTop: (0, _styles.getREM)(2)
  };
  var podiumItemLogoContainer = Object.assign({
    width: (0, _styles.getREM)(3.125),
    height: (0, _styles.getREM)(3.125),
    borderRadius: (0, _styles.getREM)(3.125 / 2),
    backgroundColor: colors.brand,
    borderStyle: 'solid',
    borderColor: COLORS.white,
    borderWidth: (0, _styles.getREM)(0.125),
    overflow: 'hidden',
    zIndex: 1
  }, boxShadows.button.all);
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    podiumItemLogoContainer.width = (0, _styles.getREM)(2.5);
    podiumItemLogoContainer.height = (0, _styles.getREM)(2.5);
    podiumItemLogoContainer.borderRadius = (0, _styles.getREM)(2.5 / 2);
  }
  var podiumItemLogoContainer_first = {
    width: (0, _styles.getREM)(4.375),
    height: (0, _styles.getREM)(4.375),
    borderRadius: (0, _styles.getREM)(4.375 / 2),
    zIndex: 0
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    podiumItemLogoContainer_first.width = (0, _styles.getREM)(3.5);
    podiumItemLogoContainer_first.height = (0, _styles.getREM)(3.5);
    podiumItemLogoContainer_first.borderRadius = (0, _styles.getREM)(3.5 / 2);
  }
  var podiumItemLogo = {
    width: '100%',
    height: '100%'
  };
  var podiumItemImageCrown = {
    width: (0, _styles.getREM)(4),
    height: (0, _styles.getREM)(4),
    position: 'absolute',
    bottom: '100%',
    left: 0,
    transform: [{
      translateX: (0, _styles.getREM)(-0.5)
    }, {
      translateY: (0, _styles.getREM)(1.6)
    }]
  };
  var podiumItemImageMedal = {
    width: (0, _styles.getREM)(2.5),
    height: (0, _styles.getREM)(2.5),
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: [{
      translateX: (0, _styles.getREM)(-2.5 / 2)
    }, {
      translateY: (0, _styles.getREM)(-0.6)
    }]
  };
  var podiumItemName = Object.assign({}, fontSemiBold, {
    fontSize: fontSize.normal,
    lineHeight: lineHeight.normal,
    color: colors.brand,
    textAlign: 'center',
    marginTop: spacing.xs
  });
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
    podiumItemName.fontSize = fontSize.s;
    podiumItemName.lineHeight = lineHeight.s;
  }
  if (bp.not([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    podiumItemName.paddingHorizontal = spacing.xs;
  }
  var podiumItemStep = {
    backgroundColor: COLORS.mushroom,
    marginTop: spacing.xs,
    minHeight: (0, _styles.getREM)(1),
    maxHeight: (0, _styles.getREM)(10)
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    podiumItemStep.display = 'none';
  }
  var podiumItemStep_first = {
    backgroundColor: COLORS.snuff,
    borderTopLeftRadius: (0, _styles.getREM)(1),
    borderTopRightRadius: (0, _styles.getREM)(1),
    minHeight: (0, _styles.getREM)(2)
  };
  var podiumItemStep_left = {
    borderTopLeftRadius: (0, _styles.getREM)(1)
  };
  var podiumItemStep_right = {
    borderTopRightRadius: (0, _styles.getREM)(1)
  };
  var podiumItemValue = Object.assign({}, tileValue, {
    marginTop: spacing.xs,
    alignSelf: 'center'
  });
  if (bp.not([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    podiumItemValue.marginHorizontal = spacing.xs;
  }
  var activityIndicator = {
    minHeight: (0, _styles.getREM)(6),
    justifyContent: 'center',
    flexGrow: 1,
    marginTop: 'auto'
  };
  if (bp.is([bp.tablet, bp.desktop])) {}
  var styles = _reactNative.StyleSheet.create({
    container: container,
    containerItem: containerItem,
    box: box,
    title: title,
    subTitle: subTitle,
    emptyMessage: emptyMessage,
    sort: sort,
    sortLabel: sortLabel,
    sortSelect: sortSelect,
    tileContainer: tileContainer,
    tile: tile,
    tileContent: tileContent,
    tileImage: tileImage,
    tileLabel: tileLabel,
    tileValue: tileValue,
    tileLinkContainer: tileLinkContainer,
    tileLink: tileLink,
    linkContainer: linkContainer,
    linkIcon: linkIcon,
    confettiContainer: confettiContainer,
    confettiLeft: confettiLeft,
    confettiRight: confettiRight,
    podium: podium,
    podiumItem: podiumItem,
    podiumItemImage: podiumItemImage,
    podiumItemImage_first: podiumItemImage_first,
    podiumItemLogoContainer: podiumItemLogoContainer,
    podiumItemLogoContainer_first: podiumItemLogoContainer_first,
    podiumItemLogo: podiumItemLogo,
    podiumItemImageCrown: podiumItemImageCrown,
    podiumItemImageMedal: podiumItemImageMedal,
    podiumItemName: podiumItemName,
    podiumItemStep: podiumItemStep,
    podiumItemStep_first: podiumItemStep_first,
    podiumItemStep_left: podiumItemStep_left,
    podiumItemStep_right: podiumItemStep_right,
    podiumItemValue: podiumItemValue,
    activityIndicator: activityIndicator
  });
  return {
    styles: styles
  };
};